import { Route, Routes } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";

import Home from "pages/Home/Home";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import LoginPage from "pages/Authentication/Login/Login";
import Signup from "pages/Authentication/Signup/Signup";
import ForgotPassword from "pages/Authentication/ForgotPassword/ForgotPassword";
import MainLayout from "Layout/MainLayout/MainLayout";

import ClaimAirdrop from "pages/ClaimAirdrop/ClaimAirdrop";
import AirdropAndStakinLayout from "Layout/AirdropAndStakinLayout/AirdropAndStakinLayout";
import Staking from "pages/Staking/Staking";

import ChatScreen from "pages/ChatScreen/ChatScreen";
import ChatScreenLayout from "Layout/ChatScreenLayout/ChatScreenLayout";
import AiCharactersLayout from "Layout/AiCharactersLayout/AiCharactersLayout";
import AiCharactersPage from "pages/AiCharactersPage/AiCharactersPage";
import axios from "axios";
import { useAppContext } from "ContextProvider/ContextProvider";

import SidebarLayout from "Layout/SidebarLayout/SidebarLayout";
import { liamaLogo } from "images";
import { db } from "db";
import AnalyticsPage from "pages/AnalyticsPage/AnalyticsPage";

export const nuke = () => {
  localStorage.clear();
  db.delete()
    .then(() => {
      console.log("Database deleted successfully.");

      // Reopen the database (optional)
      db.open().catch((err) => {
        console.error("Failed to reopen the database:", err);
      });
    })
    .catch((err) => {
      console.error("Failed to delete the database:", err);
    });
  toast.warn("Your data has been nuked!", {
    hideProgressBar: true,
  });

  window.location.href = "/chat";
};
async function get_models(setModels) {
  try {
    let api = process.env.REACT_APP_API + "/list-models";
    let { data } = await axios.get(api);
    setModels(data);
  } catch (e) {
    console.log(e);
  }
}
async function get_characters(set) {
  try {
    let api = process.env.REACT_APP_API + "/characters";
    let { data } = await axios.get(api);
    set(data);
  } catch (e) {
    console.log(e);
  }
}
function App() {
  const { myTheme } = useAppContext();
  const [models, setModels] = useState([]);
  const [aiCharacters, setAiCharacters] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [showSelectAiDropdown, setShowSelectAiDropdown] = useState(false);
  const [reload, setReload] = useState(0);
  const [balance, setBalance] = useState(0);

  const [selectedModel, setSelectedModelInternal] = useState(
    JSON.parse(localStorage.getItem("selectedModel")) || {
      id: "teme-ai",
      name: "Teme AI",
      is_premium: false,
      icon: "",
      model_type: "Chat",
      tags: [],
      is_serving: true,
    }
  );

  function setSelectedModel(model) {
    setSelectedModelInternal(model);
    localStorage.setItem("selectedModel", JSON.stringify(model));
  }
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        console.log("fetching user data");
        const token = Cookies.get("token");
        if (token) {
          const response = await axios.get(
            `${process.env.REACT_APP_API}/data`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setUserData(response.data);
          setIsLoggedIn(true);
        } else {
          setIsLoggedIn(false);
          setUserData(null);
          console.log("user not logged in");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        setIsLoggedIn(false);
        setUserData(null);
      }
    };

    fetchUserData();
  }, [reload]);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }
    const fetchBalance = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/balances`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
            },
          }
        );
        // setBalance(response.data.balance || 0);
        console.log(data);
        let Teme = data?.find(
          (item) => item.currency_id === "Teme UNS" && item.wallet_type === "Main"
        );
        setBalance(Teme?.available_balance || 0);
      } catch (error) {
        setBalance(0);
        console.error("Failed to fetch balance:", error);
      }
    };

    fetchBalance();
  }, [isLoggedIn]);

  useEffect(() => {
    get_models(setModels);
  }, []);
  useEffect(() => {
    get_characters(setAiCharacters);
  }, []);

  useEffect(() => {
    Aos.init({
      // Global settings:
      disable: false,
      startEvent: "DOMContentLoaded",
      initClassName: "aos-init",
      animatedClassName: "aos-animate",
      useClassNames: false,
      disableMutationObserver: false,
      debounceDelay: 50,
      throttleDelay: 99,
      // Animation settings:
      offset: 300,
      delay: 0,
      duration: 1000,
      easing: "ease",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
    });
  }, []);
  return (
    <div className={`${myTheme.name} bg`}>
      <ToastContainer theme="dark" position="top-center" />
      <Routes>
        {/* Start Authentication */}
        <Route
          path="/login"
          element={
            <LoginPage setReload={setReload} setIsLoggedIn={setIsLoggedIn} />
          }
        />
        <Route
          path="/sign-up"
          element={
            <Signup setIsLoggedIn={setIsLoggedIn} setReload={setReload} />
          }
        />{" "}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/* End Authentication */}
        {/* Start Landing */}
        <Route path="/" element={<MainLayout isLoggedIn={isLoggedIn} />}>
          <Route path="" element={<Home />} />
          <Route path="analytics" element={<AnalyticsPage />} />
        </Route>
        {/* End Landing */}
        <Route
          path=""
          element={
            <SidebarLayout
              setUserData={setUserData}
              userData={userData}
              setIsLoggedIn={setIsLoggedIn}
              isLoggedIn={isLoggedIn}
              aiCharacters={aiCharacters}
            />
          }
        >
          {/*Start Airdrop and staking  */}
          {/* <Route path="/" element={<AirdropAndStakinLayout />}>
            <Route
              path="Teme UNS-token"
              element={
                <ClaimAirdrop balance={balance} setBalance={setBalance} />
              }
            />
            <Route path="staking" element={<Staking />} />
          </Route> */}
          {/* end of airdrop and staking */}
          {/* start chat screen layout */}
          <Route
            path="/"
            element={
              <ChatScreenLayout
                userData={userData}
                isLoggedIn={isLoggedIn}
                setShowSelectAiDropdown={setShowSelectAiDropdown}
                showSelectAiDropdown={showSelectAiDropdown}
                aiCharacters={aiCharacters}
                setSelectedModel={setSelectedModel}
                selectedModel={selectedModel}
                models={models}
              />
            }
          >
            <Route
              path="chat"
              element={
                <ChatScreen
                  showSelectAiDropdown={showSelectAiDropdown}
                  setShowSelectAiDropdown={setShowSelectAiDropdown}
                  selectedModel={selectedModel}
                  aiCharacters={aiCharacters}
                  userData={userData}
                />
              }
            />
            <Route
              path="chat/:chatId"
              element={
                <ChatScreen
                  setShowSelectAiDropdown={setShowSelectAiDropdown}
                  selectedModel={selectedModel}
                  aiCharacters={aiCharacters}
                  userData={userData}
                />
              }
            />
            <Route
              path="chat/:chatId/:aiCharacter"
              element={
                <ChatScreen
                  setShowSelectAiDropdown={setShowSelectAiDropdown}
                  selectedModel={selectedModel}
                  aiCharacters={aiCharacters}
                  userData={userData}
                />
              }
            />
          </Route>{" "}
          {/* end chat screen layout */}
          {/* start ai character layout */}
          <Route
            path="/"
            element={<AiCharactersLayout aiCharacters={aiCharacters} />}
          >
            <Route
              path="ai-characters"
              element={
                <AiCharactersPage
                  aiCharacters={aiCharacters}
                />
              }
            />
            {/* <Route
              path="adult-characters"
              element={
                <AiCharactersPage
                  aiCharacters={aiCharacters.filter((a) =>
                    a?.tags?.includes("NSFW")
                  )}
                />
              }
            /> */}
          </Route>
          {/* {end ai character layout} */}
        </Route>
      </Routes>
    </div>
  );
}

export default App;
